const DEFAULT_SITE_NAME = "Eudemonie";

function stripTrailingSlash(value) {
  return String(value || "").replace(/\/+$/, "");
}

function normalisePath(pathname) {
  const raw = String(pathname || "/").split("#")[0].split("?")[0] || "/";
  return raw.startsWith("/") ? raw : `/${raw}`;
}

function settingValue(settings, keys) {
  for (const key of keys) {
    const value = settings?.[key];
    if (typeof value === "string" && value.trim()) return value.trim();
  }
  return "";
}

export function publicBaseUrl(settings = {}, locationObject = window.location) {
  const configured = settingValue(settings, [
    "public_site_url",
    "site_url",
    "website_url",
    "website",
    "url",
  ]);
  if (configured) return stripTrailingSlash(configured);
  const origin = locationObject?.origin || "";
  return stripTrailingSlash(origin);
}

export function buildPublicSeo({ pageDocument = null, pathname = "/", settings = {}, locationObject = window.location } = {}) {
  const siteName = settingValue(settings, ["site_name", "title", "brand_name"]) || DEFAULT_SITE_NAME;
  const title = String(pageDocument?.seo_title || pageDocument?.title || siteName).trim();
  const description = String(pageDocument?.seo_description || settings?.site_description || "").trim();
  const canonical = `${publicBaseUrl(settings, locationObject)}${normalisePath(pathname)}`;
  return { title, description, canonical };
}

function ensureMeta(name) {
  let node = document.head.querySelector(`meta[name="${name}"]`);
  if (!node) {
    node = document.createElement("meta");
    node.setAttribute("name", name);
    document.head.appendChild(node);
  }
  return node;
}

function ensurePropertyMeta(property) {
  let node = document.head.querySelector(`meta[property="${property}"]`);
  if (!node) {
    node = document.createElement("meta");
    node.setAttribute("property", property);
    document.head.appendChild(node);
  }
  return node;
}

function ensureCanonical() {
  let node = document.head.querySelector('link[rel="canonical"]');
  if (!node) {
    node = document.createElement("link");
    node.setAttribute("rel", "canonical");
    document.head.appendChild(node);
  }
  return node;
}

export function applyPublicSeo(seo = {}) {
  if (seo.title) {
    document.title = seo.title;
    ensurePropertyMeta("og:title").setAttribute("content", seo.title);
  }
  if (seo.description) {
    ensureMeta("description").setAttribute("content", seo.description);
    ensurePropertyMeta("og:description").setAttribute("content", seo.description);
  }
  if (seo.canonical) {
    ensureCanonical().setAttribute("href", seo.canonical);
    ensurePropertyMeta("og:url").setAttribute("content", seo.canonical);
  }
}
